import sharedConstants from "@lib/shared_constants";

const constContextTypes = sharedConstants.APPROVALS.TYPES;
const constCanvasWizardSteps = sharedConstants.CANVAS_WIZARD_STEPS;
const constCampaignWizardSteps = sharedConstants.CAMPAIGNS.WIZARD_STEP;
const constApprovalSections = sharedConstants.APPROVALS.APPROVAL_SECTIONS;
export const QA_AGENT_APPROVAL_SECTION = constApprovalSections.QA_AGENT_SECTION;

export const { STATUSES: approvalStatuses } = sharedConstants.INTERNAL_PERMISSIONS;
export const LOADING = "loadingStatus";

/** type specific to the available context objects that the endpoint is able to support */
export type ApprovalContextTypes = (typeof constContextTypes)[keyof typeof constContextTypes];
/** type specific to the steps of the context object */
export type CanvasWizardSteps = keyof typeof constCanvasWizardSteps;
/** Campaign approval steps: the standard wizard steps plus non-wizard approval sections (e.g. QA) */
export type CampaignApprovalSteps =
  | keyof typeof constCampaignWizardSteps
  | (typeof constApprovalSections)[keyof typeof constApprovalSections];
/** Type definition for the allowable/expected values from the constants */
export type ApprovalSteps = CanvasWizardSteps | CampaignApprovalSteps;
/** type specific to the allowed approval statuses */
export type ApprovalStatus =
  | typeof approvalStatuses.APPROVED
  | typeof approvalStatuses.DECLINED
  | typeof approvalStatuses.PENDING
  | typeof LOADING;

export interface ApprovalsSingleStepResult {
  status: ApprovalStatus;
  developer_id: string;
  time: string;
}

export type ApprovalsAllStepsResult = {
  [key in ApprovalSteps]?: ApprovalsSingleStepResult;
};

export type EngagementApprovalsContextIdStepResult = ApprovalsSingleStepResult | ApprovalsAllStepsResult;

export interface PatchEngagementApprovalsContextIdStepProps {
  contextId: string;
  contextType: ApprovalContextTypes;
  step: string;
  status: ApprovalStatus;
  isMessagingRuleApprovalOnly: boolean;
}

export interface EngagementApprovalsContextIdStepMutationResult {
  info?: string;
  warn?: string;
}
